import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// A report template's wording for the bold opening line of generated teacher
// comments. Empty phrases use the default wording.
// Proto: reports.ReportJudgementWording.
export default class ReportJudgementWording extends Fragment {
  declare [Type]: 'reports/report-judgement-wording';

  @attr('string', { defaultValue: '' })
  declare interimOnTrack: string;

  @attr('string', { defaultValue: '' })
  declare interimNotOnTrack: string;

  @attr('string', { defaultValue: '' })
  declare finalMet: string;

  @attr('string', { defaultValue: '' })
  declare finalNotMet: string;
}
